<template>
  <div>
    <Tabbar :fixedNav="true" :menuIndex="99" />
    <div class="container">
      <div class="title">
        <h2>申请试用</h2>
      </div>
      <div class="content">
        <div class="input">
          <div class="demo-input-suffix">
            <el-select class="el-input" v-model="input6" placeholder="咨询类型">
              <el-option label="e勘察" value="e勘察"> </el-option>
              <el-option label="YTKC" value="YTKC"> </el-option>
              <el-option label="文件自动化" value="文件自动化"> </el-option>
              <el-option label="大西安" value="大西安"> </el-option>
              <el-option label="岩土AI产品" value="岩土AI产品"> </el-option>
              <el-option label="其他" value="其他"> </el-option>
            </el-select>
            <el-input
              placeholder="姓名"
              prefix-icon="el-icon-s-custom"
              v-model="input1"
              class="el-input"
            >
            </el-input>
            <el-input
              placeholder="公司"
              prefix-icon="el-icon-office-building"
              v-model="input2"
              class="el-input"
            >
            </el-input>
            <!-- <el-input
              placeholder="邮箱"
              prefix-icon="el-icon-message"
              v-model="input3"
              class="el-input"
            >
            </el-input> -->
            <el-input
              placeholder="手机"
              prefix-icon="el-icon-mobile-phone"
              v-model="input4"
              class="el-input"
            >
            </el-input>
          </div>
          <div style="display:flex;">
            <el-input
              v-model="input5"
              placeholder="验证码"
              class="verification"
            ></el-input>
            <el-button
              :plain="true"
              @click="sendCode"
              :type="isDisabled ? 'info' : 'primary'"
              :disabled="isDisabled"
              >{{ codeText }}</el-button
            >
            <!-- <div class="code" @click="refreshCode">
             
              <s-identify :identifyCode="identifyCode"></s-identify>
            </div> -->
            <!-- <div class="change">
              <span>看不清？</span
              ><span @click="refreshCode" style="cursor:pointer;">换一张</span>
            </div> -->
          </div>

          <div class="btn">
            <!-- <a href="javascript:;" id="submit_btn" class="submit_btn" @click="submit"
              >提交申请</a
            > -->
            <el-button type="primary" :plain="true" @click="open"
              >提交申请</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Tabbar from "@/components/Nav/Nav.vue";
import Foot from "@/components/foot/Foot.vue";
import axios from "axios";
var timer = null;
export default {
  name: "codetest",
  components: {
    Tabbar,
    Foot,
  },
  data() {
    return {
      input1: "",
      input2: "",
      input4: "",
      input5: "",
      input6: "",
      identifyCodes: "1234567890",
      identifyCode: "",
      checked: false,
      checkList: [""],
      codeText: "发送验证码",
      isDisabled: false,
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    sendCode() {
      if (this.input4 == "") {
        this.$message.warning("请输入手机号");
        return;
      }
      //调用后台发送验证码接口，get请求
      axios
        .get("http://39.101.67.250:5096/sendSMS?mobile=" + this.input4)
        .then((res) => {
          if (res.data.code == 400) {
            this.$message.warning(res.data.msg);
            return;
          }
          this.$message.success("验证码发送成功");
          //定义按钮倒计时文字，将按钮置为不可点击状态，开始倒计时，调用服务器发送验证码接口
          let count = 60;
          timer = setInterval(() => {
            if (count > 0 && count <= 60) {
              count--;
              this.codeText = count + "s后重新发送";
              this.isDisabled = true;
            } else {
              this.codeText = "发送验证码";
              this.isDisabled = false;
              clearInterval(timer);
            }
          }, 1000);
        });
    },
    open() {
      if (this.input1 == "") {
        this.$message.warning("请输入姓名");
      } else if (this.input2 == "") {
        this.$message.warning("请输入公司名称");
      } else if (this.input4 == "") {
        this.$message.warning("请输入手机号");
      } else {
        axios
          .post("http://39.101.67.250:5096/insertData", {
            name: this.input1,
            company: this.input2,
            mobile: this.input4,
            consulting_type: this.input6,
            code: this.input5,
          })
          .then((res) => {
            if (res.data.code == 400) {
              this.$message.warning(res.data.msg);
            } else {
              clearInterval(timer);
              this.isDisabled = false;
              this.codeText = "发送验证码";
              this.$message.success("提交成功，我们会尽快与您联系");
              (this.input1 = ""),
                (this.input2 = ""),
                (this.input4 = ""),
                (this.input6 = ""),
                (this.input5 = "");
            }
          });
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
      console.log(this.identifyCode);
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .container {
    background: url(http://bu.dressplus.cn/web/img/trial_bj.png) 50% no-repeat;
    padding-top: 120px;
    height: 850px;
    background-size: 100% 100%;
    margin-bottom: 100px;
  }
  .title {
    margin: 5% 0 30px 0;
    font-size: 22px;
  }
  .content {
    display: flex;
    justify-content: center;
  }
  .input {
    width: 400px;
  }
  .demo-input-suffix .el-input {
    margin-bottom: 20px;
  }
  .verification {
    width: 40%;
  }
  .code {
    margin-left: 20px;
    width: 114px;
    height: 40px;
    border: 1px solid red;
  }
  .submit_btn {
    display: inline-block;
    line-height: 38px;
    text-align: center;
    width: 146px;
    height: 38px;
    background-color: #1db4ff;
    border: none;
    outline: none;
    color: #fff;
  }
  .change {
    margin: 20px 0 0 15px;
    font-size: 12px;
  }
  .sqnr {
    font-size: 20px;
    margin: 20px 0 20px 0;
    display: inline-block;
  }
  .el-checkbox__label {
    font-size: 16px;
  }
  .btn {
    margin: 60px 0 120px 0;
  }
}

a {
  text-decoration: none;
  /* -webkit-backface-visibility: hidden; */
}
/* ::v-deep .el-button {
  background-color: #1db4ff;
  color: #fff;
  font-size: 16px;
}
::v-deep .el-button:focus,
.el-button:hover {
  background-color: #1db4ff;
  color: #fff;
} */
</style>
